export type NotifyContent = {
  title: string,
  body: string,
  icon: string,
  onnotificationclick: function,
  timestamp: string,
  onnotificationclose: function
};

export function getNotificationPermission() {
  try {
    Notification.requestPermission().then(function(result) {
      console.info('Notification Permission ', result);
    });
  } catch (error) {
    console.warn(error);
  }
}

export const createNotification = function(notify: NotifyContent) {
  const options = {
    body: notify.body || '',
    icon: notify.icon || '',
    onnotificationclick: notify.onnotificationclick || function() {},
    timestamp: notify.timestamp || new Date().toString(),
    onnotificationclose: notify.onnotificationclose || function() {}
  };
  new Notification(notify.title, options);
};
